import { render, staticRenderFns } from "./ComposingImage.vue?vue&type=template&id=b74a52ba&"
import script from "./ComposingImage.vue?vue&type=script&lang=js&"
export * from "./ComposingImage.vue?vue&type=script&lang=js&"
import style0 from "./ComposingImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports